import React from 'react'
import './MindProbe_Contact.css';
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const Contact = () => {
    return (
        <div id='mindprobe_contact'>
            <h1 id='title'>Contact</h1>
            <div id='container'>
                <div id='numbers'>
                    <div id='card'>
                        <p id='name'>Sasandu Yenul</p>
                        <p id='person_title'>[President]</p>
                        <div id='icon_container'>
                            <div id='box1'>
                                <a href="tel:+94701422962"><FaPhoneAlt /></a>
                                <p id='number'>+94 70 142 2962</p>
                            </div>
                            <a target='_blank' rel="noreferrer" id='box2' href="https://wa.me/+94701422962?text=Hi%20I'm%20inquiring%20about%20MindProbe25."><FaWhatsapp /></a>
                        </div>
                    </div>
                    <div id='card'>
                        <p id='name'>Chelaka Amarasiri</p>
                        <p id='person_title'>[Secretary]</p>
                        <div id='icon_container'>
                            <div id='box1'>
                                <a href="tel:+94769759830"><FaPhoneAlt /></a>
                                <p id='number'>+94 76 975 9830</p>
                            </div>
                            <a target='_blank' rel="noreferrer" id='box2' href="https://wa.me/+94769759830?text=Hi%20I'm%20inquiring%20about%20MindProbe25."><FaWhatsapp /></a>
                        </div>
                    </div>
                    <div id='card'>
                        <p id='name'>Mrs. A.L.W. Alwis</p>
                        <p id='person_title'>[Master-In-Charge]</p>
                        <div id='icon_container'>
                            <div id='box1'>
                                <a href="tel:+94719186407"><FaPhoneAlt /></a>
                                <p id='number'>+94 71 918 6407</p>
                            </div>
                            <a target='_blank' rel="noreferrer" id='box2' href="https://wa.me/+94719186407?text=Hi%20I'm%20inquiring%20about%20MindProbe25."><FaWhatsapp /></a>
                        </div>
                    </div>
                </div>
                <iframe 
                    id='iframe' 
                    title="Ananda College Quiz Club Location"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3860.334364333292!2d79.86954614608912!3d6.923960358892987!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae259b927c7971b%3A0xa0b0d2538c9e3247!2sACQC%20-%20Ananda%20College%20Quiz%20Club!5e0!3m2!1sen!2slk!4v1707702001495!5m2!1sen!2slk"
                />
            </div>
        </div>
    )
}

export default Contact